<template>
    <div class="banner-one">
        <!-- <img class="banner-img-1" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1-1.png">
        <img class="banner-img-2" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1-2.png">
        <img class="banner-img-3" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1-3.png">
        <img class="banner-img-4" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1-4.png">
        <img class="banner-img-5" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1-5.png">
        <img class="banner-img-6" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1-6.png"> -->
        <lottie v-if="vm.isJson" :options="defaultOptions" :height="700" :width="1280" />
        <img v-else class="banner-img" :src="defaultOptions.animationData">
        <div class="banner-message">
            <img class="title-logo" :class="{'isImg': !vm.isJson}" :src="vm.logoImg">
            <p class="message">{{vm.message}}</p>
        </div>
    </div>
</template>
<script>
// import * as animationData from '@/../public/lottie/data.json'
export default {
  props: {
    vm: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      defaultOptions: { animationData: this.vm.jsonData }
    }
  }
}
</script>
<style lang="scss" scoped>
    .banner-one{
        width: $main-width;
        height: 700px;
        margin: 0 auto;
        // background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/main/banner-1.png');
        // background-size: 100% 100%;
        position: relative;
        .banner-img{
          width: $main-width;
          height: 700px;
        }
        .banner-message{
            position: absolute;
            top: 259px;
            left: 81px;
            width: 652px;
            padding: 30px 19px 30px 28px;
            background:rgba(248,249,252,0.2);
            border:none;
            border-radius:10px;
            text-align: left;
            .title-logo{
                width: 208px;
                height: 31px;
                margin-bottom: 25px;
                &.isImg{
                  width: 246px;
                  height: 68px;
                  margin-bottom: 10px;
                }
            }
            .message{
                font-size:18px;
                font-family:PingFangSC-Regular;
                color:#ffffff;
                text-shadow:0px 2px 0px rgba(0, 0, 0, 0.14);
                line-height: 27px;
            }
        }
        // .banner-img-1{
        //     position: absolute;
        //     top: 210px;
        //     left: 621px;
        //     width: 98px;
        //     height: 75px;
        // }
        // .banner-img-2{
        //     position: absolute;
        //     top: 396px;
        //     left: 252px;
        //     width: 91px;
        //     height: 107px;
        // }
        // .banner-img-3{
        //     position: absolute;
        //     top: 245px;
        //     left: 910px;
        //     width: 188px;
        //     height: 212px;
        // }
        // .banner-img-4{
        //     position: absolute;
        //     top: 468px;
        //     left: 843px;
        //     width: 161px;
        //     height: 71px;
        // }
        // .banner-img-5{
        //     position: absolute;
        //     top: 526px;
        //     left: 1025px;
        //     width: 62px;
        //     height: 62px;
        // }
        // .banner-img-6{
        //     position: absolute;
        //     top: 595px;
        //     left: 1021px;
        //     width: 63px;
        //     height: 14px;
        // }
    }
</style>
